import _get from 'lodash/get';

import { Google, Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';
/**
 * @summary Sends Google/Pixall Click event when hide Alpha link clicked
 * @data inventoryId
 * @events event1
 */
export async function hideAlphaCTAClick({
    data = {},
    state,
    dataLayer,
}, option) {

    const { inventoryId, parentId } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);

    const cmp = 'cta::hide-feature-listing';
    const ownerId = _get(inventory, 'owner.id', '');
    const par = parentId || 'alp';

    Pixall.sendClickEvent({
        eventSource: 'vehicle',
        eventType: 'click',
        inventory,
        label: cmp,
        listingType: 'alp',
        listingCode: ownerId,
        par,
    }, dataLayer, option);

    Google.sendClickEvent({
        eventElement: 'vehicle',
        eventResult: cmp,
    }, option);

    return { cmp, par };
}
